import React, {
  Children,
  cloneElement,
  isValidElement,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react'
import { css, StyleSheet } from 'aphrodite'
import useResponsive from 'hooks/useResponsive'
import constants from 'utils/constants'

type InfoWindow = google.maps.InfoWindow
type LatLngLiteral = google.maps.LatLngLiteral
type Map = google.maps.Map

interface GoogleMapProps {
  center?: LatLngLiteral,
  children: ReactNode,
  mapId?: string,
  zoom?: number,
}

const GoogleMap = ({
  center,
  children,
  mapId,
  zoom,
}: GoogleMapProps) => {
  const ref = useRef()
  const [map, setMap] = useState<Map>()
  const [infoWindow, setInfoWindow] = useState<InfoWindow>()
  const { compareTag } = useResponsive()
  useEffect(() => {
    if (ref.current && !map) {
      setMap(new window.google.maps.Map(ref.current, {
        scrollwheel: false,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        center: center ?? { lat: 46, lng: 6 },
        zoom: zoom ?? 7,
        mapId,
      }))
    }
    if (map) {
      setInfoWindow(new google.maps.InfoWindow({
        content: '',
      }))
    }
  }, [ref, map])
  useEffect(() => {
    if (map) {
      map.setCenter(center)
      map.setZoom(zoom)
    }
  }, [center, zoom])
  const { height, smHeight } = constants.map
  const styles = StyleSheet.create({
    container: {
      height: compareTag('md') ? height : smHeight,
    },
  })
  return (
    <div ref={ref} className={css(styles.container)}>
      {Children.map(children, (child) => isValidElement(child) && cloneElement(child, { map, infoWindow }))}
    </div>
  )
}
GoogleMap.defaultProps = {
  center: null,
  mapId: null,
  zoom: null,
}
export default GoogleMap
